var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid content"},[_c('balance-header'),_c('sakali-header',{staticClass:"mt-5",attrs:{"title":"Transferliste"}}),_c('transfer-request-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }